module.exports = __webpack_public_path__ + "img/slider1.36fa151e.png";